// extracted by mini-css-extract-plugin
export default {"strikeThroughPrice":"styles-module__strikeThroughPrice--xlkJC"};